import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { format, subDays } from "date-fns";
import { useForm } from "react-hook-form";

import { CardHelpdeskUser } from "../Cards/CardHelpdeskUser";
import {
  downloadFile,
  getBitacora,
  getUserSolicitudes,
  setCasoSelecionado,
  setFechaIFin,
  setFechaInicial,
  setLoadingHD,
} from "../../slices";
import ButtonCustom from "../CustomButtom/ButtonCustom";
import Modal from "../modal/Modal";
import { TableDetails } from "./TableDetails";
import { HeaderDetails } from "./HeaderDetails";
import { toast } from "react-toastify";

export const MisSolicitudes = () => {
  const dispatch = useDispatch();
  const { fini, ffin, usercase, casoSeleccionado, casoNivelesSeleccionado, detallesCaso } = useSelector((state) => state.helpdesk);

  const [isOpenD, setIsOpenD] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      fini: null,
      ffin: null,
    },
  });

  const onSubmit = async (data) => {
    dispatch(setFechaInicial(format(new Date(data.fini), "yyyy-MM-dd")));
    dispatch(setFechaIFin(format(new Date(data.ffin), "yyyy-MM-dd")));
    try {
      dispatch(setLoadingHD(true));
      await dispatch(getUserSolicitudes(data));
      dispatch(setLoadingHD(false));
    } catch (error) {
      toast.error(error.msg);
      dispatch(setLoadingHD(false));
    }
  };
 

  const onClear = async ()=> {
    setDate()
     try {
      dispatch(setLoadingHD(true));
      await dispatch(getUserSolicitudes({
        fini: fini, 
        ffin: ffin
      }));
    } catch (error) {
      toast.error(error.msg);
      dispatch(setLoadingHD(false));
    }   
  };

  const setDate = async () => {
    dispatch(setFechaInicial(format(subDays(new Date(Date.now()), 180), "yyyy-MM-dd")));
    dispatch(setFechaIFin(format(new Date(Date.now()), "yyyy-MM-dd")));
    setValue("fini", format(subDays(new Date(Date.now()), 180), "yyyy-MM-dd"));
    setValue("ffin", format(new Date(Date.now()), "yyyy-MM-dd"));
  };

  const getSolicitud = () => {
     try {
      dispatch(setLoadingHD(true));
      setTimeout(async ()=> {
        await dispatch(getUserSolicitudes({
          fini: fini, 
          ffin: ffin
        }));
      }, 3000) 
     } catch (error) {
      toast.error(error.msg);
      dispatch(setLoadingHD(false));
    }   
  };


  const modalDHide = () => {
    setIsOpenD(false);    
  }
  const getDetalles = async (value, infocase) => {
    try {
      dispatch(setLoadingHD(true));
      dispatch(setCasoSelecionado(infocase))
      dispatch(getBitacora(value, infocase.id_hd2_organizacion_niveles))
      setIsOpenD(true);
    } catch (error) {
      toast.error(error.msg);
      dispatch(setLoadingHD(false));
    }
  }


    const handleDownload = async (e) => {
      try {
        await dispatch(downloadFile(e))
        
      } catch (error) {
        toast.error(error.msg);
      }
    }

  useEffect(() => {
    setDate();
    getSolicitud()
    // eslint-disable-next-line
  }, []);


  return (
    <>
      <Modal
        handleClose={modalDHide} 
        isOpen={isOpenD} 
        header='Seguimiento de Caso' 
        invoiceNum={' '}
        size='modal-xl'
      >
        <HeaderDetails 
          tituloprincipal={"DETALLES CASO"} 
          area={casoSeleccionado.desc_area} 
          nivel={casoNivelesSeleccionado.replaceAll(',', ' -> ')} 
          prioridad={casoSeleccionado.prioridad_name}
          titulo={casoSeleccionado.title} 
          descripcion={casoSeleccionado.description}
        />
        <div className="row">
          <div className="col-md-12 col-lg-12"> 
            <hr />
            <h2 className="font-weight-bold">HISTORICO DEL CASO</h2>             
            <TableDetails data={detallesCaso} onClick={handleDownload}/>
          </div>
        </div>
      </Modal> 
    
      <div className="col-md-12">
        <h2>Mis solicitudes</h2>
        <hr className="my-1" />
        
        <div>
          <div className="px-1 py-2 mt-2 bg-white border rounded">
            <div className="col-12 mb-2">
              <form
                className="row col-12 col-md-12"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-2">
                  <div className="form-group">
                    <label>Fecha inicial</label>
                    <input
                      type="date"
                      className="form-control"
                      {...register("fini")}
                    />
                  </div>
                  {errors.fini && (<p className='text-danger mb-0'>{errors ? errors.fini?.message : ''}</p>)}
                </div>
                <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-2">
                  <div className="form-group">
                    <label>Fecha final</label>
                    <input
                      type="date"
                      className="form-control"
                      {...register("ffin")}
                    />
                  </div>
                  {errors.ffin && (<p className='text-danger mb-0'>{errors ? errors.ffin?.message : ''}</p>)}
                </div>
                <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-2 pt-4 mb-2">
                  <ButtonCustom classnames="btn btn-danger btn-block font-weight-bold mt-2">
                    Buscar &nbsp;<i className="fa fa-search"></i>
                  </ButtonCustom>
                </div>
                <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-2 pt-4">
                  <ButtonCustom 
                    type="button"
                    onClick={onClear}
                    classnames="btn btn-secondary btn-block font-weight-bold mt-2">
                    Limpiar &nbsp;<i className="fa fa-trash"></i>
                  </ButtonCustom>
                </div>
              </form>
            </div>
            <div className="col-md-12 px-2">
              <div className="row">                          
                {usercase.length > 0 ? (
                  usercase?.map((r, index) => (
                    <CardHelpdeskUser data={r} key={index} getDetalles={getDetalles}/>
                  ))
                ): (
                  <p>No hay datos</p>
                )}       
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
